import React from "react";
import cx from "classnames";
import "./Button.scss";

interface Props
  extends React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  accent: "default" | "primary";
  block?: boolean;
  disabled?: boolean;
  raised?: boolean;
  size: "lg";
}

export const Button: React.FC<Props> = props => {
  const {
    accent,
    block,
    children,
    disabled,
    raised,
    size,
    ...htmlProps
  } = props;
  return (
    <button
      disabled={disabled}
      className={cx("RctButton", `RctButton--${accent}`, `RctButton--${size}`, {
        "RctButton--block": block,
        "RctButton--disabled": disabled,
        "RctButton--raised": raised
      })}
      {...htmlProps}
    >
      {children}
    </button>
  );
};
